/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ios_Apple_Store_CancelInputs */

const en_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It appears you purchased Brave VPN on an iOS device. You'll need to visit the Apple App Store to complete your cancellation.`)
};

const id_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampaknya Anda membeli Brave VPN di perangkat iOS. Anda perlu mengunjungi Apple App Store untuk menyelesaikan pembatalan Anda.`)
};

const ms_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nampaknya anda membeli Brave VPN di peranti iOS. Anda perlu melawat Apple App Store untuk melengkapkan pembatalan anda.`)
};

const ca_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembla que vas comprar Brave VPN en un dispositiu iOS. Hauràs de visitar l'Apple App Store per completar la cancel·lació.`)
};

const cs_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdá se, že jste zakoupili Brave VPN na zařízení iOS. K dokončení zrušení budete muset navštívit Apple App Store.`)
};

const da_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det ser ud til, at du har købt Brave VPN på en iOS-enhed. Du skal besøge Apple App Store for at fuldføre din annullering.`)
};

const de_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es scheint, dass Sie Brave VPN auf einem iOS-Gerät gekauft haben. Sie müssen den Apple App Store besuchen, um Ihre Kündigung abzuschließen.`)
};

const et_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tundub, et ostsite Brave VPN-i iOS-i seadmes. Tühistamise lõpetamiseks peate külastama Apple App Store'i.`)
};

const es_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parece que compraste Brave VPN en un dispositivo iOS. Deberás visitar el Apple App Store para completar tu cancelación.`)
};

const fr_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il semble que vous ayez souscrit au VPN Brave depuis un appareil iOS. Pour annuler, veuillez vous rendre sur l’Apple App Store.`)
};

const hr_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čini se da ste kupili Brave VPN na iOS uređaju. Trebat ćete posjetiti Apple App Store za dovršavanje otkazivanja.`)
};

const it_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembra che tu abbia acquistato Brave VPN su un dispositivo iOS. Dovrai visitare l'Apple App Store per completare la cancellazione.`)
};

const lv_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izskatās, ka iegādājāties Brave VPN uz iOS ierīces. Lai pabeigtu atcelšanu, jums būs jādodas uz Apple App Store.`)
};

const lt_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panašu, kad Brave VPN pirkote iOS įrenginyje. Norėdami užbaigti atšaukimą, apsilankykite Apple App Store.`)
};

const hu_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úgy tűnik, hogy iOS-eszközön vásárolt Brave VPN-t. A lemondáshoz látogasson el az Apple App Store-ba.`)
};

const nl_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het lijkt erop dat je Brave VPN hebt gekocht op een iOS-apparaat. Je moet naar de Apple App Store gaan om je annulering te voltooien.`)
};

const nb_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det ser ut til at du kjøpte Brave VPN på en iOS-enhet. Du må åpne Apple App Store for å si opp abonnementet.`)
};

const pl_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygląda na to, że zakupiono Brave VPN na urządzeniu z iOS. Aby anulować subskrypcję, musisz odwiedzić App Store.`)
};

const pt_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parece que você comprou o Brave VPN em um dispositivo iOS. Você precisará visitar a Apple App Store para completar seu cancelamento.`)
};

const ro_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se pare că ați achiziționat Brave VPN pe un dispozitiv iOS. Trebuie să vizitați Apple App Store pentru a finaliza anularea.`)
};

const sk_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdá sa, že ste si zakúpili Brave VPN na zariadení iOS. Na dokončenie zrušenia budete musieť navštíviť Apple App Store.`)
};

const sl_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videti je, da ste Brave VPN kupili na napravi iOS. Za dokončanje preklica morate obiskati Apple App Store.`)
};

const fi_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näyttää siltä, että olet ostanut Brave VPN:n iOS-laitteella. Sinun täytyy mennä Apple App Storeen peruaksesi.`)
};

const sv_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det verkar som om du köpte Brave VPN på en iOS-enhet. Du måste besöka Apple App Store för att slutföra din avbokning.`)
};

const vi_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có vẻ như bạn đã mua Brave VPN trên thiết bị iOS. Bạn sẽ cần truy cập Apple App Store để hoàn thành việc hủy bỏ của mình.`)
};

const tr_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görünüşe göre Brave VPN'i bir iOS cihazında satın almışsınız. İptalinizi tamamlamak için Apple App Store'a gitmeniz gerekecek.`)
};

const el_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φαίνεται ότι αγοράσατε το Brave VPN σε μια συσκευή iOS. Θα πρέπει να επισκεφθείτε το Apple App Store για να ολοκληρώσετε την ακύρωση.`)
};

const bg_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изглежда, че сте закупили Brave VPN на iOS устройство. Ще трябва да посетите Apple App Store, за да завършите анулирането.`)
};

const ru_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Похоже, вы приобрели Brave VPN на устройстве с iOS. Для завершения отмены вам нужно посетить Apple App Store.`)
};

const sr_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чини се да сте купили Brave VPN на iOS уређају. Морате посетити Apple App Store да бисте завршили отказивање.`)
};

const uk_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви, здається, придбали Brave VPN на пристрої iOS. Вам потрібно відвідати Apple App Store, щоб завершити скасування.`)
};

const ka_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`როგორც ჩანს, თქვენ შეიძინეთ Brave VPN iOS მოწყობილობაზე. გთხოვთ ეწვიოთ Apple App Store-ს გაუქმებისთვის.`)
};

const hi_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऐसा लगता है कि आपने iOS डिवाइस पर Brave VPN खरीदा है। रद्दीकरण को पूरा करने के लिए आपको Apple App Store पर जाना होगा।`)
};

const th_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูเหมือนว่าคุณซื้อ Brave VPN บนอุปกรณ์ iOS คุณจะต้องไปที่ Apple App Store เพื่อทำการยกเลิกให้เสร็จสมบูรณ์`)
};

const ko_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS 기기에서 Brave VPN을 구매한 것으로 보입니다. 취소를 완료하려면 Apple App Store를 방문해야 합니다.`)
};

const zh_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您似乎是在 iOS 设备上购买了 Brave VPN。您需要访问 Apple App Store 来完成取消操作。`)
};

const zh_tw_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您似乎是在 iOS 裝置上購買了 Brave VPN。您需要前往 Apple App Store 完成取消程序。`)
};

const ja_ios_apple_store_cancel = /** @type {(inputs: Ios_Apple_Store_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOSデバイスでBrave VPNを購入したようです。キャンセルを完了するにはApple App Storeにアクセスする必要があります。`)
};

/**
* | output |
* | --- |
* | "It appears you purchased Brave VPN on an iOS device. You'll need to visit the Apple App Store to complete your cancellation." |
*
* @param {Ios_Apple_Store_CancelInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const ios_apple_store_cancel = /** @type {((inputs?: Ios_Apple_Store_CancelInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ios_Apple_Store_CancelInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ios_apple_store_cancel(inputs)
	if (locale === "ms") return ms_ios_apple_store_cancel(inputs)
	if (locale === "ca") return ca_ios_apple_store_cancel(inputs)
	if (locale === "cs") return cs_ios_apple_store_cancel(inputs)
	if (locale === "da") return da_ios_apple_store_cancel(inputs)
	if (locale === "de") return de_ios_apple_store_cancel(inputs)
	if (locale === "et") return et_ios_apple_store_cancel(inputs)
	if (locale === "es") return es_ios_apple_store_cancel(inputs)
	if (locale === "fr") return fr_ios_apple_store_cancel(inputs)
	if (locale === "hr") return hr_ios_apple_store_cancel(inputs)
	if (locale === "it") return it_ios_apple_store_cancel(inputs)
	if (locale === "lv") return lv_ios_apple_store_cancel(inputs)
	if (locale === "lt") return lt_ios_apple_store_cancel(inputs)
	if (locale === "hu") return hu_ios_apple_store_cancel(inputs)
	if (locale === "nl") return nl_ios_apple_store_cancel(inputs)
	if (locale === "nb") return nb_ios_apple_store_cancel(inputs)
	if (locale === "pl") return pl_ios_apple_store_cancel(inputs)
	if (locale === "pt") return pt_ios_apple_store_cancel(inputs)
	if (locale === "ro") return ro_ios_apple_store_cancel(inputs)
	if (locale === "sk") return sk_ios_apple_store_cancel(inputs)
	if (locale === "sl") return sl_ios_apple_store_cancel(inputs)
	if (locale === "fi") return fi_ios_apple_store_cancel(inputs)
	if (locale === "sv") return sv_ios_apple_store_cancel(inputs)
	if (locale === "vi") return vi_ios_apple_store_cancel(inputs)
	if (locale === "tr") return tr_ios_apple_store_cancel(inputs)
	if (locale === "el") return el_ios_apple_store_cancel(inputs)
	if (locale === "bg") return bg_ios_apple_store_cancel(inputs)
	if (locale === "ru") return ru_ios_apple_store_cancel(inputs)
	if (locale === "sr") return sr_ios_apple_store_cancel(inputs)
	if (locale === "uk") return uk_ios_apple_store_cancel(inputs)
	if (locale === "ka") return ka_ios_apple_store_cancel(inputs)
	if (locale === "hi") return hi_ios_apple_store_cancel(inputs)
	if (locale === "th") return th_ios_apple_store_cancel(inputs)
	if (locale === "ko") return ko_ios_apple_store_cancel(inputs)
	if (locale === "zh") return zh_ios_apple_store_cancel(inputs)
	if (locale === "zh-tw") return zh_tw_ios_apple_store_cancel(inputs)
	if (locale === "ja") return ja_ios_apple_store_cancel(inputs)
	return en_ios_apple_store_cancel(inputs)
});